export default __webpack_public_path__ + "media/images/react_icons/gym-c9912a4499fc1dd34587867590a09f3f.svg";